export default "__VITE_ASSET__DOJ4ex4T__"